import React, { useState, useEffect, useRef } from "react";
import AudioControls from "./AudioControls";
import AudioList from "./AudioList";
import Backdrop from "./Backdrop";
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import ReactHtmlParser from 'react-html-parser';
import { useGlobalContext } from './context'
import "./styles.css";



const AudioPlayer = () => {

  const {audioList, backgroundColors, API_ENDPOINT} = useGlobalContext();

  // State
  const [trackIndex, setTrackIndex] = useState(0);
  const [trackProgress, setTrackProgress] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);


 
  // Destructure for conciseness
  const { title, artist, image, text, audioSrc } = audioList[trackIndex];
  const finalAudiosrc = `${API_ENDPOINT}${audioSrc}`;
  const finalImage = `${API_ENDPOINT}${image}`;

  // Refs
  const audioRef = useRef(new Audio(finalAudiosrc));
  const intervalRef = useRef();
  const isReady = useRef(false);

  // Destructure for conciseness
  const { duration } = audioRef.current;

  const currentPercentage = duration
    ? `${(trackProgress / duration) * 100}%`
    : "0%";
  const trackStyling = `
    -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(${currentPercentage}, #fff), color-stop(${currentPercentage}, #777))
  `;

//::: add default image if the original fails
  const addDefaultSrc = (ev) => {
    ev.target.src = `${API_ENDPOINT}thumbnails/thumbnail_default.jpg`
  }
  const startTimer = () => {
    // Clear any timers already running
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      if (audioRef.current.ended) {
        toNextTrack();
      } else {
        setTrackProgress(audioRef.current.currentTime);
      }
    }, [1000]);
  };

  const onScrub = (value) => {
    // Clear any timers already running
    clearInterval(intervalRef.current);
    audioRef.current.currentTime = value;
    setTrackProgress(audioRef.current.currentTime);
  };

  const onScrubEnd = () => {
    // If not already playing, start
    if (!isPlaying) {
      setIsPlaying(true);
    }
    startTimer();
  };

  const toPrevTrack = () => {
    
    if (trackIndex - 1 < 0) {
      setTrackIndex(audioList.length - 1);
    } else {
      setTrackIndex(trackIndex - 1);
    }
    
  };

  const toNextTrack = () => {
    
    if (trackIndex < audioList.length - 1) {
      setTrackIndex(trackIndex + 1);
    } else {
      setTrackIndex(0);
    }
    
  };

  useEffect(() => {
    if (isPlaying) {
      audioRef.current.play();
      startTimer();
    } else {
      audioRef.current.pause();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying]);

  // Handles cleanup and setup when changing tracks
  useEffect(() => {
    audioRef.current.pause();

    audioRef.current = new Audio(finalAudiosrc);
    setTrackProgress(audioRef.current.currentTime);

    if (isReady.current) {
      audioRef.current.play();
      setIsPlaying(true);
      startTimer();
    } else {
      // Set the isReady ref as true for the next pass
      isReady.current = true;
    }
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackIndex]);

  useEffect(() => {
    // Pause and clean up on unmount
    return () => {
      audioRef.current.pause();
      clearInterval(intervalRef.current);
    };
  }, []);


          return (
            <MDBContainer fluid className="mt-5">
              <MDBRow>
                  <MDBCol sm="12" md="6" className="mb-5">
                      <div className="audio-player">
                          <div className="track-info">
                          <MDBRow>
                            <h2 className="title">{title}</h2>
                            <h3 className="artist mb-4">{artist}</h3>
                          </MDBRow>
                          <MDBRow className="mb-5">
                                <MDBCol sm="12" md="6" className="d-sm-none d-md-block">
                                    <img
                                    className="artwork mb-4 img-fluid"
                                    src={finalImage}
                                    onError={addDefaultSrc}
                                    alt={`track artwork for ${title} by ${artist}`}
                                  />
                                </MDBCol>
                                <MDBCol sm="12" md="6" className="text-left audio-player__textContainer">
                                    {ReactHtmlParser(text)}
                                </MDBCol>  
                            </MDBRow>
                            
                            <AudioControls
                              isPlaying={isPlaying}
                              onPrevClick={toPrevTrack}
                              onNextClick={toNextTrack}
                              onPlayPauseClick={setIsPlaying}
                            />
                            <input
                              type="range"
                              value={trackProgress}
                              step="1"
                              min="0"
                              max={duration ? duration : `${duration}`}
                              className="progress"
                              onChange={(e) => onScrub(e.target.value)}
                              onMouseUp={onScrubEnd}
                              onKeyUp={onScrubEnd}
                              style={{ background: trackStyling }}
                            />
                          </div>
                          <Backdrop
                            trackIndex={trackIndex}
                            activeColor={backgroundColors[trackIndex]}
                            isPlaying={isPlaying}
                          />
                      </div>
                  </MDBCol> 
                  <MDBCol sm="12" md="6">
                      <AudioList onChangeTrackClick={setTrackIndex} currentTrack={trackIndex}/>
                  </MDBCol> 
              </MDBRow>
        </MDBContainer>

      )
 
 
};

export default AudioPlayer;
